import React from "react";

const DashboardIcon = ({ style, size }) => (
  <svg
    style={style}
    width={size}
    height={size}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9291 9.24671V3.64834C18.9291 2.41341 18.4022 1.91943 17.0932 1.91943H13.7671C12.4581 1.91943 11.9312 2.41341 11.9312 3.64834V9.24671C11.9312 10.4816 12.4581 10.9756 13.7671 10.9756H17.0932C18.4022 10.9756 18.9291 10.4816 18.9291 9.24671Z"
      stroke="#7E858F"
      strokeWidth="1.12908"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.9291 16.6561V15.1742C18.9291 13.9393 18.4022 13.4453 17.0932 13.4453H13.7671C12.4581 13.4453 11.9312 13.9393 11.9312 15.1742V16.6561C11.9312 17.8911 12.4581 18.385 13.7671 18.385H17.0932C18.4022 18.385 18.9291 17.8911 18.9291 16.6561Z"
      stroke="#7E858F"
      strokeWidth="1.12908"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.46134 11.058V16.6564C9.46134 17.8913 8.93443 18.3853 7.6254 18.3853H4.29931C2.99028 18.3853 2.46338 17.8913 2.46338 16.6564V11.058C2.46338 9.82308 2.99028 9.3291 4.29931 9.3291H7.6254C8.93443 9.3291 9.46134 9.82308 9.46134 11.058Z"
      stroke="#7E858F"
      strokeWidth="1.12908"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.46134 3.64834V5.13026C9.46134 6.36519 8.93443 6.85917 7.6254 6.85917H4.29931C2.99028 6.85917 2.46338 6.36519 2.46338 5.13026V3.64834C2.46338 2.41341 2.99028 1.91943 4.29931 1.91943H7.6254C8.93443 1.91943 9.46134 2.41341 9.46134 3.64834Z"
      stroke="#7E858F"
      strokeWidth="1.12908"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DashboardIcon;
